import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

export const DotButton = ({ selected, onClick }) => (
  <button
    className={`my-2 ml-2 h-4 w-4 rounded-full border border-transparent embla__dot${selected ? ' is-selected border-orange-500 bg-orange-600 hover:text-white' : ' border-orange-500 bg-gray-800'}`}
    onClick={onClick}>
    <span className='sr-only'>dot button</span>
  </button>
)

export const PrevButton = ({ enabled, onClick }) => (
  <button
    className='previous absolute top-1/2 left-0 z-10 flex h-10 w-10 -translate-y-1/2 transform items-center  justify-center rounded-full opacity-40 hover:bg-white hover:opacity-100 focus:bg-white focus:opacity-100'
    onClick={onClick}
    disabled={!enabled}>
    <div className='sr-only'>Previous</div>
    <svg className='h-6 flex-1' fill='currentColor' viewBox='137.718 -1.001 366.563 644'>
      <path d='M428.36 12.5c16.67-16.67 43.76-16.67 60.42 0 16.67 16.67 16.67 43.76 0 60.42L241.7 320c148.25 148.24 230.61 230.6 247.08 247.08 16.67 16.66 16.67 43.75 0 60.42-16.67 16.66-43.76 16.67-60.42 0-27.72-27.71-249.45-249.37-277.16-277.08a42.308 42.308 0 0 1-12.48-30.34c0-11.1 4.1-22.05 12.48-30.42C206.63 234.23 400.64 40.21 428.36 12.5z' />
    </svg>
  </button>
)

export const NextButton = ({ enabled, onClick }) => (
  <button
    className='next absolute top-1/2 right-0 z-10 flex h-10 w-10 -translate-y-1/2 transform items-center justify-center rounded-full opacity-40 hover:bg-white hover:opacity-100 focus:bg-white focus:opacity-100'
    onClick={onClick}
    disabled={!enabled}>
    <div className='sr-only'>Next</div>
    <svg className='h-6' fill='currentColor' viewBox='0 0 238.003 238.003'>
      <path d='M181.776 107.719L78.705 4.648c-6.198-6.198-16.273-6.198-22.47 0s-6.198 16.273 0 22.47l91.883 91.883-91.883 91.883c-6.198 6.198-6.198 16.273 0 22.47s16.273 6.198 22.47 0l103.071-103.039a15.741 15.741 0 0 0 4.64-11.283c0-4.13-1.526-8.199-4.64-11.313z' />
    </svg>
  </button>
)

export const SliceDotButton = ({ selected, onClick, label, image }) => (
  <>
    {label && (
      <button className='embla__dot text-brand-blue font-light focus:outline-none' onClick={onClick}>
        <span className={`-my-px ml-2 inline-block h-4 w-4 rounded-full mr-1${selected ? ' is-selected bg-orange-600' : ' bg-white'}`}></span>
        {label ? <span>{label}</span> : <span className='sr-only'>dot button</span>}
      </button>
    )}
    {image && (
      <div className={`rounded border-4 border-transparent${selected ? ' border-secondary' : ''}`}>
        <button className='m-px aspect-square w-20 rounded shadow' onClick={onClick}>
          {image ? <GatsbyImage className='object-fit h-full w-full' alt='' image={image.gatsbyImageData} /> : <span className='sr-only'>dot button</span>}
        </button>
      </div>
    )}
  </>
)
